export const STANDARDIZED_LABEL_SCOPE = {
    GLOBAL: 'GLOBAL',
    COMPANY_SPECIFIC: 'COMPANY_SPECIFIC',
    SECTOR_SPECIFIC: 'SECTOR_SPECIFIC',
    NOT_SPECIFIED: 'NOT_SPECIFIED',
} as const;

export const STANDARDIZED_LABEL_SCOPES = Object.values(STANDARDIZED_LABEL_SCOPE);

export const STANDARDIZED_LABEL_TAGS = ['EXPENSE'];
